import React, { useContext, useEffect, useState } from 'react';
import { InputGroup, Row, Form, Button, Table, Modal } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import AuthContext from '../../context/AuthContext';
import axiosInstance from '../../utils/axios';
import { showToast } from '../reusables/CommonFunction';
import { formatDisplayDate } from '../../utils/formatter';
import BusyLoaderOverlay from '../reusables/BusyLoaderOverlay';
import CustomPagination from '../reusables/CustomPagination';
import ModalDelete from '../reusables/ModalDelete';

const SMSCampaign = () => {
    let { userDetails } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [campaignName, setCampaignName] = useState("")
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isModalViewOpen, setIsModalViewOpen] = useState({});
    const [isModalEditOpen, setIsModalEditOpen] = useState({});
    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState({});
    const [campaignDetails, setCampaignDetails] = useState({ campaignName: "", campaignDate: null, message: "", sendType: "A", clinicBranchId: null });
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const pageSize = parseInt(process.env.REACT_APP_PAGINATION_PAGE_SIZE);
    const salutation = { '1': 'DR.', '2': 'MR.', '3': 'MRS.', '4': 'MISS', '5': 'MASTER' }
    const [campaigns, setCampaigns] = useState([]);

    const getSMSCampaigns = (pageNumber) => {
        setLoading(true);
        axiosInstance
            .get(`/sms-campaigns/`, {
                params: {
                    q: campaignName, 
                    clinicId: userDetails.clinic_id,
                    page: pageNumber
                }
            })
            .then(response => {
                if (response.status === 200) {
                    setCampaigns(response.data.data);
                    setTotalCount(response.data.count);
                }
            })
            .catch(error => {
                showToast("error", "Failed to fetch SMS Campaign details");
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const onPressSearchCampaigns = (oEvent) => {
        oEvent.preventDefault();
        setCurrentPage(1); // Reset to the first page
        getSMSCampaigns(1);
    }

    const onPressEditCampaign = (oEvent, pCampaign) => {
        oEvent.preventDefault();
        setCampaignDetails({
            campaignName: pCampaign.campaign_name,
            campaignDate: pCampaign.campaign_date,
            message: pCampaign.campaign_message,
            sendType: pCampaign.campaign_type,
            clinicBranchId: pCampaign.clinic_branch_id || null
        });
        setIsModalEditOpen({ ['isModalEditOpen_' + pCampaign.campaign_id]: true });
    }

    const onPressDeleteCampaign = (oEvent, pCampaignId) => {
        oEvent.preventDefault();
        setIsModalDeleteOpen({ ['isModalDeleteOpen_' + pCampaignId]: true })
    }

    const onPressSubmitDeleteCampaign = (oEvent, pCampaignId) => {
        oEvent.preventDefault();
        setLoading(true);
        axiosInstance
            .delete(`/sms-campaigns/${pCampaignId}/`)
            .then(response => {
                if (response.status === 200) {
                    showToast("success", response.data.message);
                    setIsModalDeleteOpen({ ['isModalDeleteOpen_' + pCampaignId]: false })
                    setCurrentPage(1); // Reset to the first page
                    getSMSCampaigns(1)
                } else if (response.status === 403 && response.data.detail === "Your clinic plan has expired.") {
                    showToast("error", "You cannot delete this campaign as your clinic plan has expired. Please renew your plan to manage campaigns.");
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 403 && error.response.data.detail === "Your clinic plan has expired.") {
                    showToast("error", "You cannot delete this campaign as your clinic plan has expired. Please renew your plan to manage campaigns.");
                } else {
                    showToast("error", "Failed to delete campaign details. Please try again later.");
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(() => {
        getSMSCampaigns(currentPage);
    }, [currentPage]);

    return (
        <>
            <Row className="ml-3 mr-3 mb-3">
                <div className='col-md-12'>
                    <InputGroup className="mb-3 col-md-4 pl-0" >
                        <Form.Control
                            type="text"
                            name="campaignName"
                            onChange={(oEvent) => setCampaignName(oEvent.target.value)}
                            placeholder="Enter Campaign Name..."
                            value={campaignName}
                        />
                        <Button type="submit" variant="outline-secondary" onClick={(oEvent) => onPressSearchCampaigns(oEvent)}>
                            Search
                        </Button>
                    </InputGroup>

                    {campaigns.length > 0 ? (
                        <>
                            <Table bordered hover responsive>
                                <thead light="true">
                                    <tr>
                                        <th style={{ width: "2rem" }}>#</th>
                                        <th style={{ width: "12rem" }}>Campaign Name</th>
                                        <th style={{ width: "5rem" }}>Campaign Type</th>
                                        <th style={{ minWidth: "200px", wordWrap: "break-word", whiteSpace: "normal" }}>Message</th>
                                        <th style={{ width: "7rem" }}>Campaign Date</th>
                                        <th style={{ width: "5rem" }}>Status</th>
                                        <th style={{ width: "5rem" }}>Patients</th>
                                        <th style={{ width: "9rem" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {campaigns.map((campaign, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{campaign.campaign_name}</td>
                                            <td>{campaign.campaign_type === 'A' ? 'All' : 'Custom'}</td>
                                            <td style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{campaign.campaign_message}</td>
                                            <td>{formatDisplayDate(campaign.campaign_date)}</td>
                                            <td>{{ P: 'Pending', S: 'Sent', F: 'Failed' }[campaign.campaign_status] || 'Unknown'}</td>
                                            <td>
                                                {campaign.campaign_type === 'C' ? (
                                                    <>
                                                        <Button variant="primary" size="sm" onClick={() => { setIsModalViewOpen({ ['isModalViewOpen_' + campaign.campaign_id]: true }) }}>View</Button>
                                                        <Modal size="lg" backdrop="static" keyboard={false} centered
                                                            show={isModalViewOpen['isModalViewOpen_' + campaign.campaign_id]} onHide={() => { setIsModalViewOpen({ ['isModalViewOpen_' + campaign.campaign_id]: false }) }}>
                                                            <Modal.Header closeButton>
                                                                <Modal.Title>Patients in Campaign</Modal.Title>
                                                            </Modal.Header>
                                                            <Modal.Body>
                                                                <Table bordered hover size="sm" responsive style={{ maxHeight: "300px", overflowY: "auto" }}>
                                                                    <thead className="table-light">
                                                                        <tr>
                                                                            <th>#</th>
                                                                            <th>Patient Name</th>
                                                                            <th>Mobile Number</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {campaign.patients.map((patient, idx) => (
                                                                            <tr key={idx}>
                                                                                <td>{idx + 1}</td>
                                                                                <td>{salutation[patient.salutation] || ""} {patient.patient_name}</td>
                                                                                <td>{patient.mobile_number}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </Table>
                                                            </Modal.Body>
                                                            <Modal.Footer>
                                                                <Button variant="secondary" onClick={() => { setIsModalViewOpen({ ['isModalViewOpen_' + campaign.campaign_id]: false }) }}>Close</Button>
                                                            </Modal.Footer>
                                                        </Modal>
                                                    </>
                                                ) : (
                                                    <span className="text-muted">N/A</span>
                                                )}
                                            </td>
                                            <td>
                                                {(campaign.campaign_type === 'A' && campaign.campaign_status === 'P') && (
                                                    <Row>
                                                        <div className='col-6'>
                                                            <Button variant="secondary" size="sm" onClick={oEvent => onPressEditCampaign(oEvent, campaign)}>Edit</Button>
                                                            <Modal size="lg" backdrop="static" keyboard={false} centered
                                                                show={isModalEditOpen['isModalEditOpen_' + campaign.campaign_id]} onHide={() => { setIsModalEditOpen({ ['isModalEditOpen_' + campaign.campaign_id]: false }) }}>
                                                                <Modal.Header closeButton>
                                                                    <Modal.Title>Edit Campaign</Modal.Title>
                                                                </Modal.Header>
                                                                <Modal.Body>
                                                                    <Form>
                                                                        <Form.Group controlId="campaignName">
                                                                            <Form.Label>Campaign Name</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                placeholder="Enter Campaign Name"
                                                                                value={campaignDetails.campaignName}
                                                                                onChange={e => setCampaignDetails({ ...campaignDetails, campaignName: e.target.value })}
                                                                            />
                                                                        </Form.Group>
                                                                        <Form.Group controlId="campaignDate">
                                                                            <Form.Label>Campaign Date</Form.Label>
                                                                            <Form.Control
                                                                                type="date"
                                                                                value={campaignDetails.campaignDate}
                                                                                onChange={e => setCampaignDetails({ ...campaignDetails, campaignDate: e.target.value })}
                                                                            />
                                                                        </Form.Group>
                                                                        <Form.Group controlId="message">
                                                                            <Form.Label>Message</Form.Label>
                                                                            <Form.Control
                                                                                as="textarea"
                                                                                rows={3}
                                                                                placeholder="Enter Campaign Message"
                                                                                value={campaignDetails.message}
                                                                                onChange={e => setCampaignDetails({ ...campaignDetails, message: e.target.value })}
                                                                            />
                                                                        </Form.Group>
                                                                    </Form>
                                                                </Modal.Body>
                                                                <Modal.Footer>
                                                                    <Button variant="secondary" onClick={() => { setIsModalEditOpen({ ['isModalEditOpen_' + campaign.campaign_id]: false }) }}>Close</Button>
                                                                    <Button variant="primary" onClick={async (oEvent) => {
                                                                        oEvent.preventDefault();
                                                                        setIsSubmitting(true);
                                                                        try {
                                                                            const payload = {
                                                                                clinic_id: userDetails.clinic_id,
                                                                                clinic_branch_id: campaignDetails.clinicBranchId || null,
                                                                                campaign_name: campaignDetails.campaignName,
                                                                                campaign_date: campaignDetails.campaignDate,
                                                                                campaign_message: campaignDetails.message,
                                                                                campaign_type: campaignDetails.sendType,
                                                                            };
                                                                            const response = await axiosInstance.put(`/sms-campaigns/${campaign.campaign_id}/`, payload);
                                                                            if (response.status === 200) {
                                                                                showToast("success", "SMS Campaign updated successfully.", {
                                                                                    onClose: () => {
                                                                                        setIsModalEditOpen({ ['isModalEditOpen_' + campaign.campaign_id]: false });
                                                                                        getSMSCampaigns(currentPage);
                                                                                    }
                                                                                });
                                                                                setCampaignDetails({ campaignName: "", campaignDate: null, message: "", sendType: "A", clinicBranchId: null });
                                                                                setIsSubmitting(false);
                                                                            } else if (response.status === 403 && response.data.detail === "Your clinic plan has expired.") {
                                                                                showToast("error", "You cannot update this campaign as your clinic plan has expired. Please renew your plan to manage campaigns.");
                                                                                setIsSubmitting(false);
                                                                            }
                                                                        } catch (error) {
                                                                            if (error.response && error.response.status === 400) {
                                                                                showToast("warning", error.response.data.message);
                                                                            } else if (error.response && error.response.status === 403 && error.response.data.detail === "Your clinic plan has expired.") {
                                                                                showToast("error", "You cannot update this campaign as your clinic plan has expired. Please renew your plan to manage campaigns.");
                                                                            } else {
                                                                                showToast("error", "Failed to update SMS Campaign");
                                                                            }
                                                                            setIsSubmitting(false);
                                                                        }
                                                                    }} disabled={isSubmitting}>
                                                                        {isSubmitting ? 'Updating...' : 'Update Campaign'}
                                                                    </Button>
                                                                </Modal.Footer>
                                                            </Modal>
                                                        </div>

                                                        <div className='col-6 pl-0'>
                                                            <Button variant="danger" size="sm" onClick={oEvent => onPressDeleteCampaign(oEvent, campaign.campaign_id)}>Delete</Button>
                                                            <ModalDelete show={isModalDeleteOpen['isModalDeleteOpen_' + campaign.campaign_id]} modalTitle="Campaign" modalBody={campaign.campaign_name}
                                                                onHide={() => setIsModalDeleteOpen({ ['isModalDeleteOpen_' + campaign.campaign_id]: false })}
                                                                onSubmit={oEvent => onPressSubmitDeleteCampaign(oEvent, campaign.campaign_id)} />
                                                        </div>
                                                    </Row>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            <CustomPagination
                                totalCount={totalCount}
                                currentPage={currentPage}
                                pageSize={pageSize}
                                onPageChange={setCurrentPage} />
                        </>
                    ) : (
                        <div className="text-center">
                            <p>No SMS Campaigns found.</p>
                        </div>
                    )}
                </div>
                <ToastContainer />
                <BusyLoaderOverlay show={loading} />
            </Row>
        </>
    )
}

export default SMSCampaign;